import { environment } from "./environments/environment";

export const AppConfig = {
    API_BASE_URL: environment.apiUrl,
    CCC_BASE_URL: environment.cccUrl
}
